<template>
<v-container fluid>
    <v-card class="ma-sm-2" outlined>
        <v-card-title class="d-flex">
            <v-btn icon @click="goToGroupList('home')">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            Challenge summary

            <v-btn color="info" @click="goToGroupList('verify')" small class="ml-5">
                Verify
            </v-btn>

            <v-btn color="info" @click="goToGroupList('edit')" small class="ml-5" v-if="isSuperAdmin">
                Edit
            </v-btn>
        </v-card-title>
        <v-card-text v-if="!challengeInfo.loading">
            <p class="text-h6 text--primary">
                {{challengeInfo.name}} ({{challengeInfo.admin.name}})<br />
                {{_formatData('date',challengeInfo.startDateText)}} - {{_formatData('date',challengeInfo.endDateText)}}
            </p>
            <!-- <p v-if="challengeInfo.summaryDate">
                Last updated {{_formatData('date',challengeInfo.summaryDate.toDate())}}
            </p> -->
        </v-card-text>
        
        <v-spacer></v-spacer>
        <v-card-text>
            <v-row class="align-content-start flex-wrap" width="80%">
                <v-col>
                    <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field required v-model="computedDateFormattedStartDateReport" label="Start Date*" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="startDate" no-title required @input="menu1 = false" :min="minDate" :max="maxDate"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                    <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field required v-model="computedDateFormattedEndDateReport" label="End Date*" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="endDate" no-title required @input="menu2 = false" :min="minDate" :max="maxDate"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                    <v-btn color="primary" dark class="ml-5 mt-3" @click="toReport" :loading="loading">
                        Submit
                    </v-btn>
                    <v-btn color="primary" dark class="ml-5 mt-3" @click="toExport" :loading="isExporting">
                        Export
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>

        <v-progress-linear indeterminate color="yellow darken-2" v-if="challengeInfo.loading || !agesOfUsers.categories.length"></v-progress-linear>
    </v-card>
    <v-card class="d-flex ma-sm-2 flex-column flex-md-row flex-sm-row flex-wrap" flat tile v-if="!loading && agesOfUsers.categories.length">
        <total-summary-component :totalSummaryInfo="totalSummaryInfo" />
        <number-of-users-summary-component :memberNumbers="numberOfRecords" />
        <number-of-users-summary-component :memberNumbers="memberNumbers" />
        <!-- <age-of-users-summary-component :agesOfUsers="agesOfUsersx" /> -->
        <chart-group-component :chartInfo="agesOfUsers" />
        <report-challenge-component :reportData="reportData" :challengeId="this.id" v-if="!challengeInfo.isIndividual"/>
        <report-challenge-data-person-component :userList="reportData" v-if="challengeInfo.isIndividual" title="Report"/>
        <!-- <export-challenge-component :exportFilterData="exportFilterData" /> -->
    </v-card>
    <v-snackbar
      v-model="snackbar"
      multi-line
    >
      {{ text }}

      <template v-slot:actions>
        <v-btn
          color="red"
          variant="text"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import {
    getFunctions,
    httpsCallable
} from "firebase/functions";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import TotalSummaryComponent from "../components/TotalSummaryComponent.vue";
import NumberOfUsersSummaryComponent from "../components/NumberOfUsersSummaryComponent.vue";
import ChartGroupComponent from "../components/ChartGroupComponent.vue";
import ReportChallengeComponent from "../components/ReportChallengeDataComponent.vue";
import ReportChallengeDataPersonComponent from "../components/ReportChallengeDataPersonComponent.vue";
import formatData from "../utils/formatData";
import getChallengeInfoById from "../data/getChallengeInfoById";
import getChallengeSummary from "../data/getChallengeSummary";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import bqGetReportChallengeData from "../data/bqGetReportChallengeData";
import bqGetReportChallengeDataByGroup from "../data/bqGetReportChallengeDataByGroup";
import colors from 'vuetify/lib/util/colors';
import moment from "moment";
import "firebase/compat/storage";
export default {
    name: 'ChallengeSummary',
    metaInfo: {
        title: 'Challenge Summary'
    },
    components: {
        TotalSummaryComponent,
        NumberOfUsersSummaryComponent,
        ChartGroupComponent,
        ReportChallengeComponent,
        ReportChallengeDataPersonComponent
    },
    data() {
        return {
            challengeInfo: {
                loading: false,
                name: '',
                admin: {
                    name: ''
                },
                summaryDate: ''

            },
            numberOfRecords: {
                title: 'Activities',
                labels: [],
                lastUpdate: new Date(),
                series: [],
                colors: [colors.orange.lighten3, colors.green.lighten3, colors.blueGrey.lighten3, colors.purple.lighten3, colors.cyan.lighten3]
            },
            memberNumbers: {
                title: 'Participants',
                labels: [],
                lastUpdate: new Date(),
                series: [],
                colors: [colors.cyan.lighten3, colors.cyan.darken3]
            },
            totalSummaryInfo: {
                lastUpdate: new Date(),
                data: {
                    totalWeightLoss: 0,
                    totalWorkoutMins: 0,
                    totalStep: 0,
                    totalPBWF: 0
                }
            },
            agesOfUsers: {
                chartTitle: "Age groups",
                title: "Age groups",
                categories: [],
                stacked: true,
                labelsShowX: true,
                labelsShowY: true,
                columnWidth: '80%',
                formatNumber: 0,
                series: [{
                    name: 'Male',
                    data: [],
                    color: colors.cyan.lighten3
                }, {
                    name: 'Female',
                    data: [],
                    color: colors.cyan.darken3
                }]
            },
            // agesOfUsersx: {
            //     lastUpdate: new Date(),
            //     data: {
            //         categories: [],
            //         male: [],
            //         female: []
            //     }
            // },
            exportFilterData: {
                competition_id: '',
                startDate: '',
                endDate: ''
            },
            reportFilterData: {
                competition_id: '',
                startDate: '',
                endDate: ''
            },
            reportData: [],
            minDate: '',
            maxDate: '',
            menu1: false,
            menu2: false,
            startDate: '',
            endDate: '',
            requiredRule: [
                v => !!v
            ],
            loading: false,
            isExporting: false,
            checkInterval: 3000,
            snackbar: false,
            text: `Convert to Excel failed`,
        };
    },
    created() {
        var vm = this;
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        //competition id
        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
        computedDateFormattedStartDateReport() {
            return this.formatDate(this.startDate);
        },
        computedDateFormattedEndDateReport() {
            return this.formatDate(this.endDate);
        }
    },
    methods: {
        initialize() {
            (async () => {
                this.challengeInfo.loading = true;
                if (localStorage.getItem('challengeId') && localStorage.getItem('challengeId') != this.id) {
                    localStorage.removeItem('challengeId');
                    localStorage.removeItem('startDate');
                    localStorage.removeItem('endDate');
                }
                if (localStorage.getItem('startDate') && localStorage.getItem('endDate')) {
                    this.startDate = localStorage.getItem('startDate');
                    this.endDate= localStorage.getItem('endDate');
                    await this.toPrepareData(this.startDate, this.endDate);
                }
                else{
                    await this.toPrepareData();
                }
                this.challengeInfo.loading = false;
                this.loading = false;
            })();
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },

        //router
        goToGroupList(type) {
            if (type == "summary") {
                this.$router.push(`/challengesummary/${this.id}`);
            } else if (type == "verify") {
                this.$router.push(`/challengeverify/${this.id}`);
            } else if (type == "home") {
                this.$router.push(`/challenge`);
            } else if (type == "edit") {
                this.$router.push(`/challenge-edit/${this.id}`);
            } else {
                this.$router.push(`/challenge/${this.id}`);
            }
        },
        toSetNewDate(challengeInfo, startDate, endDate){
            if( startDate != undefined && endDate != undefined ){
                challengeInfo.startDate = new Date(startDate + ' 00:00:00');
                challengeInfo.startDateText = moment(startDate, 'YYYY-MM-DD').toDate();
                challengeInfo.startDateDatepicker = startDate;
                
                challengeInfo.endDate = new Date(endDate + ' 00:00:00');
                challengeInfo.endDateText = moment(endDate, 'YYYY-MM-DD').toDate();
                challengeInfo.endDateDatepicker = endDate;
            }
            return challengeInfo;
        },
        async toPrepareData (startDate, endDate){

            let challengeInfo = await getChallengeInfoById(this.id);
            this.challengeInfo = challengeInfo;
            this.minDate = challengeInfo.startDateDatepicker;
            this.maxDate = challengeInfo.endDateDatepicker;
            
            challengeInfo = await this.toSetNewDate(challengeInfo, startDate, endDate);     
            localStorage.setItem('challengeId', this.id);
            localStorage.setItem('startDate', challengeInfo.startDateDatepicker);
            localStorage.setItem('endDate', challengeInfo.endDateDatepicker);
            challengeInfo = await getChallengeSummary(this.id, challengeInfo.startDateDatepicker, challengeInfo.endDateDatepicker);
            challengeInfo = await this.toSetNewDate(challengeInfo, startDate, endDate);
            
            if (challengeInfo.owner != undefined) {
                challengeInfo.admin = await getUserInfoByUserId(challengeInfo.owner);
            }

            this.challengeInfo = challengeInfo;
            this.startDate = this.challengeInfo.startDateDatepicker;
            this.endDate = this.challengeInfo.endDateDatepicker;

            //Member number
            this.memberNumbers.labels = ['Male', 'Female'];
            this.memberNumbers.series = [challengeInfo.summary.memberNumbers.male, challengeInfo.summary.memberNumbers.female];

            //Number of records
            this.numberOfRecords.labels = ['PHR', 'Sleep', 'Drink',  'PBWF', 'Workout'];
            this.numberOfRecords.series = [
                challengeInfo.summary.numberOfRecords.healthData, 
                challengeInfo.summary.numberOfRecords.sleep, 
                challengeInfo.summary.numberOfRecords.water, 
                challengeInfo.summary.numberOfRecords.food,
                challengeInfo.summary.numberOfRecords.workout,
            ];

            //Total Summary
            this.totalSummaryInfo.data = challengeInfo.summary.totalSummary;
            this.agesOfUsers.data = challengeInfo.summary.agesOfUsers;
            this.agesOfUsers.categories = this.agesOfUsers.data.categories;
            this.agesOfUsers.series[0].data = this.agesOfUsers.data.male;
            this.agesOfUsers.series[1].data = this.agesOfUsers.data.female;
            if( !this.agesOfUsers.series[0].data.length && !this.agesOfUsers.series[1].data.length ){
                this.agesOfUsers.noData = true;
            }

            //get group report table
            if( challengeInfo.isIndividual ){
                this.reportData = await bqGetReportChallengeDataByGroup(this.id, 'user', challengeInfo.startDateDatepicker, challengeInfo.endDateDatepicker);
            }
            else{
                this.reportData = await bqGetReportChallengeData(this.id, challengeInfo.startDateDatepicker, challengeInfo.endDateDatepicker);
            }
        },  

        async toReport( ){
            this.loading = true;
            if( !this.startDate ){
                if( localStorage.getItem('startDate') ){
                    this.startDate = localStorage.getItem('startDate');
                }
                else{
                    this.startDate = this.minDate;
                }
            }
            if( !this.endDate ){
                if( localStorage.getItem('endDate') ){
                    this.endDate = localStorage.getItem('endDate');
                }
                else{
                    this.endDate = this.maxDate;
                }
            }
            if( this.startDate && this.endDate ){
                await this.toPrepareData(this.startDate, this.endDate);                
            }
            this.loading = false;
        },

        //function for add delay
        async wait (delay) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                }, delay)
            })
        },

        async toDownloadFile(){
            const storage = firebase.app().storage("gs://thaisook_bigquery_export");
            const storageRef = storage.ref();
            const downloadFile = `challenge-${this['id']}-000000000000.csv`;

            try {
                // Replace this with your actual file checking logic
                const fileRef = await storageRef.child(downloadFile).getDownloadURL();
                if (fileRef) {
                    window.location = fileRef;
                } else {
                    return false;
                }
            } catch (error) {
                console.error("Error checking file:", error);
                return false;
            }
        },

        async toCheckFile(){
            const storage = firebase.app().storage("gs://thaisook_bigquery_export");
            const storageRef = storage.ref();
            const checkFile = `challenge-${this['id']}-000000000000.bom_added`;

            try {
                // Replace this with your actual file checking logic
                const fileRef = await storageRef.child(checkFile).getDownloadURL();
                if (fileRef) {
                    return true;
                } else {
                    return false;
                }
            } catch (error) {
                console.error("Error checking file:", error);
                return false;
            }
        },

        async toExport( ) {
            this.isExporting = true;
            const app = firebase.app();
            const functions = getFunctions(app, 'asia-east2');
            const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

            const prefixFileName = `challenge-${this['id']}-`;
            await queryThaisookViewBigQuery({
                    query: `
                    CREATE TEMP FUNCTION totalHealthpoint(food numeric,water numeric, sleep numeric, other numeric, workout numeric, step numeric,date_str string)
                        RETURNS numeric
                        LANGUAGE js
                        AS r"""
                          var date = new Date(date_str);
                          var sum =0;
                          var totalWorkout = workout + step;
                          if(totalWorkout > 5 ) totalWorkout = 5;
                          if(food > 5) food = 5;
                          if(sleep > 2) sleep = 2;
                          if(water > 0) other = 1;
                          if(other > 1) other = 1;
                          if(date <= new Date('2025-07-23')) {
                            sum = totalWorkout + food + sleep + other;
                          } else {
                            other = other + sleep + water;
                            if(other > 1) other = 1;
                            sum = totalWorkout + food + other;
                          }
                          
                          if (sum > 10) sum = 10;
                          return sum;
                        """;
                    EXPORT DATA OPTIONS (
                        uri='gs://thaisook_bigquery_export/${prefixFileName}*.csv',
                        format='CSV',
                        overwrite=true,
                        header=true,
                        field_delimiter=','
                    ) AS (
                        WITH data As (
                            SELECT 
                                date(CA.date) date,
                                time(CA.date) time,

                                U.firstname,
                                U.lastname,
                                U.employeeId,
                                U.gender,
                                U.birthdate,
                                U.height,
                                U.uid,

                                G.groupId,
                                G.name groupName,

                                CA.category,
                                CA.activityType,
                                null source,
                                CA.reportFlag,
                            
                                CA.steps,
                                CA.totalWorkout,
                                CA.distance,
                                CA.calories,
                                CA.menu,
                                CA.serving,

                                CU.startWeight,
                                CU.startBMI,
                                CU.endWeight,
                                CU.endBMI,
                                null weight,
                                null waist,

                                null waterVolume,
                                null sleepHours,
                                null healthPoint,

                                IF(CU.startWeightVerify, 'true', 'false') startWeightVerify,
                                IF(CU.endWeightVerify, 'true', 'false') endWeightVerify
                            FROM 
                                thaisook_view.competition_users CU
                                join thaisook_view.groups G
                                    on CU.groupId = G.groupId
                                join thaisook_view.users U
                                    on CU.uid = U.uid
                                join activity_view.competition_activities CA 
                                    on CU.uid = CA.uid
                            WHERE
                                CU.competitionId = CA.competitionId
                                and CU.competitionId = '${this['id']}'
                                and date(CA.date) >= date(CU.startWeightDate)
                            UNION ALL
                            SELECT 
                                date(WO.date) date,
                                time(WO.date) time,

                                U.firstname,
                                U.lastname,
                                U.employeeId,
                                U.gender,
                                U.birthdate,
                                U.height,
                                U.uid,

                                G.groupId,
                                G.name groupName,

                                'workout' category,
                                'steps' activityType,
                                WO.source,
                                null reportFlag,

                                WO.steps,
                                null totalWorkout,
                                null distance,
                                null calories,
                                null menu,
                                null serving,

                                CU.startWeight,
                                CU.startBMI,
                                CU.endWeight,
                                CU.endBMI,
                                null weight,
                                null waist,

                                null sleepHours,
                                null waterVolume,
                                null healthPoint,

                                IF(CU.startWeightVerify, 'true', 'false') startWeightVerify,
                                IF(CU.endWeightVerify, 'true', 'false') endWeightVerify
                            FROM 
                                thaisook_view.competition_users CU
                                join thaisook_view.groups G
                                    on CU.groupId = G.groupId
                                join thaisook_view.users U
                                    on CU.uid = U.uid
                                join thaisook_view.competition C
                                    on C.competitionId = CU.competitionId
                                join activity_view.workout WO
                                    on WO.uid = CU.uid 
                                    and date(WO.date) between date('${this['startDate']}') and date('${this['endDate']}')
                            WHERE
                                CU.competitionId = '${this['id']}'
                                and date(WO.date) >= date(CU.startWeightDate)
                                and time(WO.date) = '00:00:00'

                            UNION ALL

                            SELECT 
                                date(WA.date) date,
                                time(WA.date) time,

                                U.firstname,
                                U.lastname,
                                U.employeeId,
                                U.gender,
                                U.birthdate,
                                U.height,
                                U.uid,

                                G.groupId,
                                G.name groupName,

                                'water' category,
                                null activityType,
                                null source,
                                null reportFlag,

                                null steps,
                                null totalWorkout,
                                null distance,
                                null calories,
                                null menu,
                                null serving,

                                CU.startWeight,
                                CU.startBMI,
                                CU.endWeight,
                                CU.endBMI,
                                null weight,
                                null waist,

                                WA.waterVolume,
                                null sleepHours,
                                null healthPoint,

                                IF(CU.startWeightVerify, 'true', 'false') startWeightVerify,
                                IF(CU.endWeightVerify, 'true', 'false') endWeightVerify
                            FROM 
                                thaisook_view.competition_users CU
                                join thaisook_view.groups G
                                    on CU.groupId = G.groupId
                                join thaisook_view.users U
                                    on CU.uid = U.uid
                                join thaisook_view.competition C
                                    on C.competitionId = CU.competitionId
                                join activity_view.water WA
                                    on WA.uid = CU.uid 
                                    and date(WA.date) between date('${this['startDate']}') and date('${this['endDate']}')
                            WHERE
                                CU.competitionId = '${this['id']}'
                                and date(WA.date) >= date(CU.startWeightDate)
                            UNION ALL

                            SELECT 
                                date(SL.date) date,
                                time(SL.date) time,

                                U.firstname,
                                U.lastname,
                                U.employeeId,
                                U.gender,
                                U.birthdate,
                                U.height,
                                U.uid,

                                G.groupId,
                                G.name groupName,

                                'sleep' category,
                                null activityType,
                                null source,
                                null reportFlag,

                                null steps,
                                null totalWorkout,
                                null distance,
                                null calories,
                                null menu,
                                null serving,

                                CU.startWeight,
                                CU.startBMI,
                                CU.endWeight,
                                CU.endBMI,
                                null weight,
                                null waist,

                                null waterVolume,
                                SL.sleepHours,
                                null healthPoint,

                                IF(CU.startWeightVerify, 'true', 'false') startWeightVerify,
                                IF(CU.endWeightVerify, 'true', 'false') endWeightVerify
                            FROM 
                                thaisook_view.competition_users CU
                                join thaisook_view.groups G
                                    on CU.groupId = G.groupId
                                join thaisook_view.users U
                                    on CU.uid = U.uid
                                join thaisook_view.competition C
                                    on C.competitionId = CU.competitionId
                                join activity_view.sleep SL
                                    on SL.uid = CU.uid 
                                    and date(SL.date) between date('${this['startDate']}') and date('${this['endDate']}')
                            WHERE
                                CU.competitionId = '${this['id']}'
                                and date(SL.date) >= date(CU.startWeightDate)
                            UNION ALL

                            SELECT 
                                date(HD.date) date,
                                time(HD.date) time,

                                U.firstname,
                                U.lastname,
                                U.employeeId,
                                U.gender,
                                U.birthdate,
                                U.height,
                                U.uid,

                                G.groupId,
                                G.name groupName,

                                'weight' category,
                                null activityType,
                                null source,
                                null reportFlag,

                                null steps,
                                null totalWorkout,
                                null distance,
                                null calories,
                                null menu,
                                null serving,

                                CU.startWeight,
                                CU.startBMI,
                                CU.endWeight,
                                CU.endBMI,
                                HD.weight,
                                HD.waist,

                                null waterVolume,
                                null sleepHours,
                                null healthPoint,

                                IF(CU.startWeightVerify, 'true', 'false') startWeightVerify,
                                IF(CU.endWeightVerify, 'true', 'false') endWeightVerify
                            FROM 
                                thaisook_view.competition_users CU
                                join thaisook_view.groups G
                                    on CU.groupId = G.groupId
                                join thaisook_view.users U
                                    on CU.uid = U.uid
                                join thaisook_view.competition C
                                    on C.competitionId = CU.competitionId
                                join thaisook_view.healthdata HD
                                    on HD.uid = CU.uid 
                                    and date(HD.date) between date('${this['startDate']}') and date('${this['endDate']}')
                            WHERE
                                CU.competitionId = '${this['id']}'
                                and HD.category in('weight', 'fat')
                                and date(HD.date) >= date(CU.startWeightDate)
                            UNION ALL

                            SELECT 
                                date(HP.date) date,
                                time(HP.date) time,

                                U.firstname,
                                U.lastname,
                                U.employeeId,
                                U.gender,
                                U.birthdate,
                                U.height,
                                U.uid,

                                G.groupId,
                                G.name groupName,

                                'healthpoint' category,
                                null activityType,
                                null source,
                                null reportFlag,

                                null steps,
                                null totalWorkout,
                                null distance,
                                null calories,
                                null menu,
                                null serving,

                                CU.startWeight,
                                CU.startBMI,
                                CU.endWeight,
                                CU.endBMI,
                                null weight,
                                null waist,

                                null waterVolume,
                                null sleepHours,
                                totalHealthpoint(HP.foodScore, HP.waterScore, HP.sleepScore, HP.otherScore, HP.workoutScore, HP.stepScore, cast(HP.date as string)) as healthPoint,

                                IF(CU.startWeightVerify, 'true', 'false') startWeightVerify,
                                IF(CU.endWeightVerify, 'true', 'false') endWeightVerify
                            FROM 
                                thaisook_view.competition_users CU
                                join thaisook_view.groups G
                                    on CU.groupId = G.groupId
                                join thaisook_view.users U
                                    on CU.uid = U.uid
                                join thaisook_view.competition C
                                    on C.competitionId = CU.competitionId
                                join activity_view.healthpoint HP
                                    on HP.uid = CU.uid 
                                    and date(HP.date) between date('${this['startDate']}') and date('${this['endDate']}')
                            WHERE
                                CU.competitionId = '${this['id']}'
                                and date(HP.date) >= date(CU.startWeightDate)
                        )
                        select * from data order by date, time
                    )
                `
                })
                .then( async(result) => {
                    this.isExporting = false;
                    const resultData = JSON.parse(result.data);
                    if (resultData.errors) {
                        // alert(resultData.errors);
                    } else {
                        for( let i = 0; i < 5; i++ ){
                            await this.wait(this.checkInterval);
                            const isFileExist = await this.toCheckFile();
                            if( isFileExist ){
                                await this.toDownloadFile();
                                return;
                            }
                        }
                        this.snackbar = true;
                    }
                });
        }

    },
};
</script>